import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Typography from '@mui/material/Typography';

import BtnGradient from 'src/components/common/button/BtnGradient';
import BtnOutlineGradient from 'src/components/common/button/BtnOutlineGradient';

const typographyLabel = {
  fontSize: '16px',
  lineHeight: '16.8px',
  fontWeight: 500
};

interface DialogConfirmProps {
  open: boolean;
  content: string;
  onSubmit: () => void;
  onClose: () => void;
};

const DialogConfirm: React.FC<DialogConfirmProps> = (props) => {

  const handleClose = () => {
    props.onClose();
  };

  const handleSubmit = () => {
    props.onSubmit();
  }

  return (
    <Dialog
      open={props.open}
      onClose={handleClose}
      sx={{
        '& .MuiDialog-paper': {
          width: '100%',
          maxWidth: '500px',
          m: '0px'
        }
      }}
    >

      <DialogContent
        sx={{
          p: '20px'
        }}
      >
        <Typography sx={{ ...typographyLabel }}>
          {props.content}
        </Typography>
      </DialogContent>

      <DialogActions
        style={{
          justifyContent: 'right',
          padding: '16px'
        }}
      >
        <BtnOutlineGradient text='キャンセル' handleButtonClick={handleClose} />
        <BtnGradient
          text='OK'
          handleButtonClick={handleSubmit}
          sx={{
            background: '#DA4453',
            '&:hover': { opacity: 0.8, bgcolor: '#a70c0cf2' }
          }}
        />
      </DialogActions>
    </Dialog>
  );
};

export default DialogConfirm;
